import { useMutation } from 'react-query'
import postDeleteCard from '@/src/card-linking/queries/PostDeleteCard'

const usePostDeleteCard = () => {
    return useMutation('postDeleteCard', postDeleteCard)
}

export default usePostDeleteCard
